import React from 'react';
import { transformIframes } from '../../../utils/utils';
import styles from './styles/SituationBody.module.css';
import MediaPlayer from '../../../utils/MediaPlayer';
import { TUTORIAL_TARGETS, tutorialAttr } from '../../../tutorials';

// displayed content during preview
const SituationBody = ({ situation }) => {

    const shouldAutoplay = situation.autoplay === true;

    return (
        <div className={styles.container}>
            {situation.audio && (
                <div className={styles.mediaContainer}>
                    <MediaPlayer
                        key={situation.audio}  
                        src={situation.audio}
                        autoplay={shouldAutoplay}
                    />
                    {situation.audioLabel && situation.audioLabel.trim() !== "" && (
                        <div className={styles.mediaLabel}>{situation.audioLabel}</div>
                    )}
                </div>
            )}


            {situation.image && (
                <div className={styles.imageContainer}>
                    <img src={situation.image} alt={situation.title} className={styles.image} />
                </div>
            )}

            {situation.document && (
                <div className={styles.pdfContainer}>
                    <iframe
                        src={`${situation.document}#toolbar=0&navpanes=0&scrollbar=0`}
                        className={styles.pdfFrame}
                        title="Document"
                    />
                </div>
            )}

            <div
                className={styles.text}
                dangerouslySetInnerHTML={{ __html: transformIframes(situation.text) }}
                {...tutorialAttr(TUTORIAL_TARGETS.PREVIEW_SITUATION_TEXT)}
            />
        </div>
    );
};

export default SituationBody;
